import React, { useState, useEffect } from 'react';
import {
  Card, Table, Button, Form, Row, Col, Badge, Modal,
  Spinner, OverlayTrigger, Tooltip, InputGroup, Pagination
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const TarifKamar = () => {
  const navigate = useNavigate();

  // Helper IP API
  const getApiUrl = () => {
    return localStorage.getItem('api_url') || 'http://localhost:8000';
  };

  // State Data Klasifikasi & Selected Klasifikasi
  const [klasifikasiList, setKlasifikasiList]       = useState([]);
  const [selectedKlasifikasi, setSelectedKlasifikasi] = useState('');
  const [isLoadingKlasifikasi, setIsLoadingKlasifikasi] = useState(false);

  // State Data Tarif Kamar & Loading
  const [tarifKamarList, setTarifKamarList] = useState([]);
  const [isLoading, setIsLoading]           = useState(true);
  const [fetchError, setFetchError]         = useState(null);

  // State Clock
  const [time, setTime] = useState({ date: '', clock: '' });

  // State Filter & Pagination
  const [searchQuery, setSearchQuery]   = useState('');
  const [currentPage, setCurrentPage]   = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // State Modal Form (Edit/Tambah Tarif Kamar)
  const [showFormModal, setShowFormModal] = useState(false);
  const [isEditMode, setIsEditMode]       = useState(false);
  const [formData, setFormData]           = useState({
    kd_kelas: '',
    nm_kelas: '',
    tarifpaket: 0,
    tarif: 0,
    sts_paket: 'Paket',
    selisih: 'Tetap',
    paramedis: 0,
    komisirujuk: 0
  });
  const [isSaving, setIsSaving]           = useState(false);
  const [formFeedback, setFormFeedback]   = useState(null);

  // State Modal Detail
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedTarif, setSelectedTarif]     = useState(null);

  // State Kelas Options
  const [kelasOptions, setKelasOptions] = useState([]);

  // Mock Data Klasifikasi (Fallback dari show_klasifikasi)
  const mockKlasifikasiData = [
    { kd_klasifikasi: "001", nm_klasifikasi: "BPJS KESEHATAN" },
    { kd_klasifikasi: "002", nm_klasifikasi: "UMUM / PRIBADI" },
    { kd_klasifikasi: "003", nm_klasifikasi: "ASURANSI SWASTA" },
    { kd_klasifikasi: "004", nm_klasifikasi: "INHEALTH" }
  ];

  // Mock Data Tarif Kamar (Fallback dari show_tarifkamar)
  const mockTarifKamarData = [
    {
      "flag_pemasaran11": "",
      "flag_pemasaran21": "",
      "kd_kelas": "002",
      "kd_subdivisi": "",
      "komisirujuk": 0,
      "nm_kelas": "Kelas 1",
      "nm_subdivisi": "",
      "paramedis": 0,
      "selisih": "Tetap",
      "sts_paket": "Paket",
      "tarif": 0,
      "tarifpaket": 420000
    },
    {
      "flag_pemasaran11": "",
      "flag_pemasaran21": "",
      "kd_kelas": "021",
      "kd_subdivisi": "",
      "komisirujuk": 0,
      "nm_kelas": "HCU",
      "nm_subdivisi": "",
      "paramedis": 0,
      "selisih": "Tetap",
      "sts_paket": "Paket",
      "tarif": 0,
      "tarifpaket": 420000
    },
    {
      "flag_pemasaran11": "",
      "flag_pemasaran21": "",
      "kd_kelas": "001",
      "kd_subdivisi": "",
      "komisirujuk": 0,
      "nm_kelas": "VVIP",
      "nm_subdivisi": "",
      "paramedis": 0,
      "selisih": "Tetap",
      "sts_paket": "Paket",
      "tarif": 0,
      "tarifpaket": 850000
    },
    {
      "flag_pemasaran11": "",
      "flag_pemasaran21": "",
      "kd_kelas": "003",
      "kd_subdivisi": "",
      "komisirujuk": 0,
      "nm_kelas": "Kelas 2",
      "nm_subdivisi": "",
      "paramedis": 0,
      "selisih": "Tetap",
      "sts_paket": "Paket",
      "tarif": 0,
      "tarifpaket": 320000
    },
    {
      "flag_pemasaran11": "",
      "flag_pemasaran21": "",
      "kd_kelas": "004",
      "kd_subdivisi": "",
      "komisirujuk": 0,
      "nm_kelas": "Kelas 3",
      "nm_subdivisi": "",
      "paramedis": 0,
      "selisih": "Tetap",
      "sts_paket": "Paket",
      "tarif": 0,
      "tarifpaket": 200000
    }
  ];

  // Helper Format Rupiah
  const formatRp = (val) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(val || 0);
  };

  // ── Fetch Master Klasifikasi (show_klasifikasi) ──
  const fetchKlasifikasi = async () => {
    setIsLoadingKlasifikasi(true);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_klasifikasi`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      } catch {
        res = await fetch(`${apiUrl}/show_klasifikasi`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      let list = [];
      if (json?.list_klasifikasi && Array.isArray(json.list_klasifikasi)) {
        list = json.list_klasifikasi;
      } else if (Array.isArray(json)) {
        list = json;
      } else {
        list = mockKlasifikasiData;
      }

      setKlasifikasiList(list);
      if (list.length > 0 && !selectedKlasifikasi) {
        const defaultKd = list[0].kd_klasifikasi || list[0].kd_klas || list[0].kode || list[0].kd_penjamin || '001';
        setSelectedKlasifikasi(defaultKd);
        fetchTarifKamar(defaultKd);
      }
    } catch (err) {
      console.warn('Gagal fetch /show_klasifikasi, menggunakan data mock:', err);
      setKlasifikasiList(mockKlasifikasiData);
      if (!selectedKlasifikasi) {
        setSelectedKlasifikasi('001');
        fetchTarifKamar('001');
      }
    } finally {
      setIsLoadingKlasifikasi(false);
    }
  };

  // ── Fetch Tarif Kamar (show_tarifkamar dengan parameter kd_klasifikasi) ──
  const fetchTarifKamar = async (kdKlas = selectedKlasifikasi) => {
    setIsLoading(true);
    setFetchError(null);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_tarifkamar`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kd_klasifikasi: kdKlas })
        });
      } catch {
        res = await fetch(`${apiUrl}/show_tarifkamar?kd_klasifikasi=${encodeURIComponent(kdKlas)}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      if (json?.list_tarifkamar && Array.isArray(json.list_tarifkamar)) {
        setTarifKamarList(json.list_tarifkamar);
      } else if (Array.isArray(json)) {
        setTarifKamarList(json);
      } else {
        setTarifKamarList(mockTarifKamarData);
      }
    } catch (err) {
      console.warn(`Gagal fetch /show_tarifkamar (kd_klasifikasi: ${kdKlas}):`, err);
      setTarifKamarList(mockTarifKamarData);
      setFetchError('Menggunakan data lokal. Gagal terhubung ke backend server.');
    } finally {
      setIsLoading(false);
    }
  };

  // ── Fetch Kelas Options ──
  const fetchKelasOptions = async () => {
    try {
      const res = await fetch(`${getApiUrl()}/show_kelas`);
      if (res.ok) {
        const json = await res.json();
        if (json?.list_kelas) {
          setKelasOptions(json.list_kelas);
        }
      }
    } catch (err) {
      console.warn("Gagal terhubung ke endpoint /show_kelas:", err);
    }
  };

  // Clock Effect & Initial Fetch
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID') + ' WIB',
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    fetchKlasifikasi();
    fetchKelasOptions();
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter Data Tarif Kamar
  const filteredData = tarifKamarList.filter(item => {
    const q = searchQuery.toLowerCase();
    return (
      (item.kd_kelas || '').toLowerCase().includes(q) ||
      (item.nm_kelas || '').toLowerCase().includes(q) ||
      (item.sts_paket || '').toLowerCase().includes(q) ||
      (item.selisih || '').toLowerCase().includes(q)
    );
  });

  // Pagination Logic
  const indexOfLast  = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages   = Math.ceil(filteredData.length / itemsPerPage);

  // Handler Open Modal Form
  const handleOpenFormModal = (item = null) => {
    setFormFeedback(null);
    if (item) {
      setIsEditMode(true);
      setFormData({
        kd_kelas: item.kd_kelas || '',
        nm_kelas: item.nm_kelas || '',
        tarifpaket: item.tarifpaket || 0,
        tarif: item.tarif || 0,
        sts_paket: item.sts_paket || 'Paket',
        selisih: item.selisih || 'Tetap',
        paramedis: item.paramedis || 0,
        komisirujuk: item.komisirujuk || 0
      });
    } else {
      setIsEditMode(false);
      setFormData({
        kd_kelas: '',
        nm_kelas: '',
        tarifpaket: 0,
        tarif: 0,
        sts_paket: 'Paket',
        selisih: 'Tetap',
        paramedis: 0,
        komisirujuk: 0
      });
    }
    setShowFormModal(true);
  };

  const handleSaveTarifKamar = async (e) => {
    e.preventDefault();
    if (!formData.kd_kelas.trim() || !formData.nm_kelas.trim()) {
      setFormFeedback({ type: 'danger', text: 'Kode Kelas dan Nama Kelas wajib diisi!' });
      return;
    }

    setIsSaving(true);
    setFormFeedback(null);
    const apiUrl = getApiUrl();
    const endpoint = isEditMode ? `${apiUrl}/edit_tarifkamar` : `${apiUrl}/tambah_tarifkamar`;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, kd_klasifikasi: selectedKlasifikasi })
      });

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      setFormFeedback({ type: 'success', text: json?.message || `Tarif Kamar (${formData.nm_kelas}) berhasil disimpan!` });

      if (isEditMode) {
        setTarifKamarList(prev => prev.map(t => t.kd_kelas === formData.kd_kelas ? { ...formData } : t));
      } else {
        setTarifKamarList(prev => [formData, ...prev]);
      }
      setTimeout(() => setShowFormModal(false), 1200);

    } catch (err) {
      console.warn(`Gagal simpan ke ${endpoint}:`, err);
      if (isEditMode) {
        setTarifKamarList(prev => prev.map(t => t.kd_kelas === formData.kd_kelas ? { ...formData } : t));
      } else {
        setTarifKamarList(prev => [formData, ...prev]);
      }
      setFormFeedback({
        type: 'success',
        text: `[Demo Mode] Data Tarif Kamar (${formData.nm_kelas}) diperbarui pada tampilan.`
      });
      setTimeout(() => setShowFormModal(false), 1200);
    } finally {
      setIsSaving(false);
    }
  };

  // Handler Open Modal Detail
  const handleOpenDetailModal = (item) => {
    setSelectedTarif(item);
    setShowDetailModal(true);
  };

  // Nama Klasifikasi Aktif
  const selectedKlasObj = klasifikasiList.find(k => (k.kd_klasifikasi || k.kd_klas || k.kode || k.kd_penjamin) === selectedKlasifikasi);
  const namaKlasifikasiAktif = selectedKlasObj ? (selectedKlasObj.nm_klasifikasi || selectedKlasObj.nm_klas || selectedKlasObj.nama || selectedKlasObj.klasifikasi) : selectedKlasifikasi;

  return (
    <div style={styles.appContainer}>
      {/* ══ NAVBAR COMPACT HEADER ══ */}
      <nav style={styles.navbarCustom} className="d-flex align-items-center justify-content-between text-white shadow-sm">
        <div className="d-flex align-items-center gap-2">
          <span className="fw-bold fs-6 tracking-wide d-flex align-items-center gap-2">
            <i className="bi bi-door-open-fill text-warning fs-5"></i>
            SIMRS — Master Daftar Tarif Kamar
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-light" style={{ fontSize: '0.72rem', opacity: 0.9 }}>
            <i className="bi bi-calendar-event me-1"></i>{time.date} |
            <i className="bi bi-clock me-1 ms-1"></i>{time.clock}
          </span>
          <Button
            variant="warning"
            size="sm"
            className="fw-semibold text-dark shadow-sm"
            style={{ padding: '0.2rem 0.75rem', fontSize: '0.75rem', borderRadius: '6px' }}
            onClick={() => navigate('/home')}
          >
            <i className="bi bi-house-door-fill me-1"></i> Kembali ke Home
          </Button>
        </div>
      </nav>

      {/* ══ MAIN CONTENT ══ */}
      <div style={styles.mainContent}>

        {/* ── Stats Summary Bar ── */}
        <Row className="g-2 mb-2">
          <Col md={3} sm={6}>
            <div style={{ background: '#f0fdfa', border: '1.5px solid #0d948822', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#0d9488', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-building-fill-check text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0d9488', lineHeight: 1.1 }}>{tarifKamarList.length}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Total Kelas Kamar</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#eff6ff', border: '1.5px solid #2563eb22', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#2563eb', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-currency-dollar text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '0.92rem', color: '#2563eb', lineHeight: 1.1 }}>
                  {formatRp(tarifKamarList.length > 0 ? tarifKamarList.reduce((acc, t) => acc + (t.tarifpaket || 0), 0) / tarifKamarList.length : 0)}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Rata-rata Tarif Paket</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#f5f3ff', border: '1.5px solid #7c3aed22', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#7c3aed', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-box-seam text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#7c3aed', lineHeight: 1.1 }}>
                  {tarifKamarList.filter(t => (t.sts_paket || '').toLowerCase() === 'paket').length}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Status Ber-Paket</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#fffbeb', border: '1.5px solid #d9770622', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#d97706', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-tags-fill text-white fs-5"></i>
              </div>
              <div>
                <div className="fw-bold text-truncate" style={{ fontSize: '0.85rem', color: '#d97706', lineHeight: 1.1, maxWidth: '140px' }}>
                  {namaKlasifikasiAktif || 'Semua Klasifikasi'}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Klasifikasi Tarif Aktif</div>
              </div>
            </div>
          </Col>
        </Row>

        {/* ── Main Card ── */}
        <Card style={styles.mainCard} className="shadow-sm border-0">
          {/* Card Header */}
          <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }}
            className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span className="fw-bold">
              <i className="bi bi-card-checklist me-1 text-warning"></i>
              Tabel Master Tarif Kamar per Klasifikasi Tarif
            </span>
            <div className="d-flex gap-2 align-items-center">
              <Button
                variant="success"
                size="sm"
                className="fw-bold d-flex align-items-center gap-1 shadow-sm"
                style={{ fontSize: '0.73rem', borderRadius: '6px', background: '#16a34a', borderColor: '#16a34a' }}
                onClick={() => handleOpenFormModal(null)}
              >
                <i className="bi bi-plus-circle-fill"></i> Tambah Tarif Kamar Baru
              </Button>
              <Button
                variant="outline-light"
                size="sm"
                onClick={() => fetchTarifKamar(selectedKlasifikasi)}
                disabled={isLoading}
                style={{ fontSize: '0.73rem', borderRadius: '6px' }}
              >
                {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Refresh Data
              </Button>
            </div>
          </div>

          <Card.Body style={{ padding: '0.6rem' }}>
            {/* ── Filter Controls (Select Klasifikasi Tarif) ── */}
            <Row className="g-2 mb-2 align-items-center">
              {/* Select Klasifikasi Tarif (kd_klasifikasi) */}
              <Col md={5} sm={12}>
                <Form.Group className="d-flex align-items-center gap-2">
                  <Form.Label className="mb-0 fw-bold text-dark" style={{ fontSize: '0.78rem', whiteSpace: 'nowrap' }}>
                    <i className="bi bi-diagram-3-fill text-teal me-1"></i>Klasifikasi Tarif:
                  </Form.Label>
                  <Form.Select
                    size="sm"
                    value={selectedKlasifikasi}
                    onChange={e => {
                      const newKd = e.target.value;
                      setSelectedKlasifikasi(newKd);
                      fetchTarifKamar(newKd);
                      setCurrentPage(1);
                    }}
                    style={{ fontSize: '0.8rem', fontWeight: '600' }}
                    disabled={isLoadingKlasifikasi}
                  >
                    {klasifikasiList.map((k, idx) => {
                      const kd = k.kd_klasifikasi || k.kd_klas || k.kode || k.kd_penjamin;
                      const nm = k.nm_klasifikasi || k.nm_klas || k.nama || k.klasifikasi;
                      return (
                        <option key={idx} value={kd}>
                          {kd} — {nm}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Search Bar */}
              <Col md={4} sm={8}>
                <InputGroup size="sm">
                  <InputGroup.Text style={{ background: '#f8fafc', fontSize: '0.78rem' }}>
                    <i className="bi bi-search text-muted"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Cari Kode Kelas, Nama Kelas, Status Paket..."
                    value={searchQuery}
                    onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  />
                  {searchQuery && (
                    <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')}>
                      ✕
                    </Button>
                  )}
                </InputGroup>
              </Col>

              {/* Rows Per Page */}
              <Col md={3} sm={4}>
                <Form.Select
                  size="sm"
                  value={itemsPerPage}
                  onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value={10}>10 Baris per Halaman</option>
                  <option value={20}>20 Baris per Halaman</option>
                  <option value={50}>50 Baris per Halaman</option>
                  <option value={100}>100 Baris per Halaman</option>
                </Form.Select>
              </Col>
            </Row>

            {fetchError && (
              <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchError}
              </div>
            )}

            {/* ── Data Table ── */}
            <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 280px)', overflowY: 'auto' }}>
              <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th className="text-center" style={{ width: '35px' }}>#</th>
                    <th className="text-center" style={{ width: '95px' }}>Kode Kelas</th>
                    <th>Nama Kelas Kamar</th>
                    <th className="text-end" style={{ color: '#4ade80' }}>Tarif Paket</th>
                    <th className="text-end d-none d-md-table-cell">Tarif Non-Paket</th>
                    <th className="text-center d-none d-md-table-cell">Status Paket</th>
                    <th className="text-center d-none d-md-table-cell">Selisih</th>
                    <th className="text-center" style={{ width: '100px' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        <Spinner animation="border" variant="teal" size="sm" className="me-2" />
                        <span>Memuat data tarif kamar untuk klasifikasi <strong>{selectedKlasifikasi}</strong>...</span>
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item, idx) => (
                      <tr key={idx}>
                        <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>

                        {/* Kode Kelas */}
                        <td className="text-center">
                          <Badge bg="dark" className="font-monospace px-2 py-1" style={{ fontSize: '0.73rem', backgroundColor: '#1e293b' }}>
                            {item.kd_kelas}
                          </Badge>
                        </td>

                        {/* Nama Kelas Kamar */}
                        <td className="fw-bold text-dark" style={{ fontSize: '0.78rem' }}>
                          {item.nm_kelas}
                        </td>

                        {/* Tarif Paket */}
                        <td className="text-end fw-bold text-success" style={{ fontSize: '0.78rem' }}>
                          {formatRp(item.tarifpaket)}
                        </td>

                        {/* Tarif Non-Paket */}
                        <td className="text-end text-muted d-none d-md-table-cell" style={{ fontSize: '0.74rem' }}>
                          {item.tarif > 0 ? formatRp(item.tarif) : '—'}
                        </td>

                        {/* Status Paket */}
                        <td className="text-center d-none d-md-table-cell">
                          <Badge bg={item.sts_paket === 'Paket' ? 'primary' : 'secondary'} style={{ fontSize: '0.68rem' }}>
                            {item.sts_paket || '—'}
                          </Badge>
                        </td>

                        {/* Selisih */}
                        <td className="text-center d-none d-md-table-cell">
                          <Badge bg="info" text="dark" style={{ fontSize: '0.68rem' }}>
                            {item.selisih || 'Tetap'}
                          </Badge>
                        </td>

                        {/* Tombol Aksi */}
                        <td className="text-center">
                          <div className="d-flex justify-content-center align-items-center gap-1">
                            <OverlayTrigger placement="top" overlay={<Tooltip>Detail Rincian Tarif Kamar</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-info"
                                style={{ padding: '0.15rem 0.4rem', fontSize: '0.7rem', borderRadius: '5px' }}
                                onClick={() => handleOpenDetailModal(item)}
                              >
                                <i className="bi bi-eye-fill"></i>
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit Tarif Kamar</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-primary"
                                style={{ padding: '0.15rem 0.4rem', fontSize: '0.7rem', borderRadius: '5px' }}
                                onClick={() => handleOpenFormModal(item)}
                              >
                                <i className="bi bi-pencil-square"></i>
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4 text-muted">
                        Tidak ada data tarif kamar yang ditemukan untuk klasifikasi penjamin ini.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* ── Pagination ── */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination size="sm" className="mb-0">
                  <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                  <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                  {[...Array(Math.min(totalPages, 10))].map((_, i) => (
                    <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  {totalPages > 10 && <Pagination.Ellipsis disabled />}
                  <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                  <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                </Pagination>
              </div>
            )}

            {/* ── Footer Info ── */}
            <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
              <span>
                Menampilkan{' '}
                <strong>{filteredData.length > 0 ? indexOfFirst + 1 : 0}–{Math.min(indexOfLast, filteredData.length)}</strong>{' '}
                dari <strong>{filteredData.length}</strong> data tarif (Total: {tarifKamarList.length})
              </span>
              <span>Parameter (kd_klasifikasi): <strong>{selectedKlasifikasi}</strong> | IP: <strong>{getApiUrl()}</strong></span>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* ══ MODAL DETAIL TARIF KAMAR ══ */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered size="md">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-door-open-fill text-warning fs-5"></i>
            <span>Detail Rincian Tarif Kamar</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          {selectedTarif && (
            <div>
              <Card className="border-0 shadow-sm mb-3">
                <Card.Body className="p-3" style={{ fontSize: '0.78rem' }}>
                  <div className="border-bottom pb-2 mb-2">
                    <div className="text-muted" style={{ fontSize: '0.68rem' }}>Kode Kelas</div>
                    <Badge bg="dark" className="fs-6 font-monospace mb-1">{selectedTarif.kd_kelas}</Badge>
                    <div className="fw-bold text-dark fs-6">{selectedTarif.nm_kelas}</div>
                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>Klasifikasi: <strong>{namaKlasifikasiAktif} ({selectedKlasifikasi})</strong></div>
                  </div>

                  <Row className="g-2">
                    <Col md={6}>
                      <div className="p-2 rounded bg-success-subtle border border-success-subtle">
                        <div className="text-muted" style={{ fontSize: '0.65rem' }}>Tarif Paket</div>
                        <div className="fw-bold text-success" style={{ fontSize: '0.9rem' }}>{formatRp(selectedTarif.tarifpaket)}</div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="p-2 rounded bg-light border">
                        <div className="text-muted" style={{ fontSize: '0.65rem' }}>Tarif Non-Paket</div>
                        <div className="fw-bold text-dark" style={{ fontSize: '0.9rem' }}>{selectedTarif.tarif > 0 ? formatRp(selectedTarif.tarif) : '—'}</div>
                      </div>
                    </Col>
                    <Col md={6} className="mt-2">
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Status Paket</div>
                      <Badge bg={selectedTarif.sts_paket === 'Paket' ? 'primary' : 'secondary'}>{selectedTarif.sts_paket || '—'}</Badge>
                    </Col>
                    <Col md={6} className="mt-2">
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Aturan Selisih</div>
                      <Badge bg="info" text="dark">{selectedTarif.selisih || 'Tetap'}</Badge>
                    </Col>
                    <Col md={6} className="mt-2 border-top pt-2">
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Paramedis</div>
                      <div className="fw-semibold text-dark">{formatRp(selectedTarif.paramedis)}</div>
                    </Col>
                    <Col md={6} className="mt-2 border-top pt-2">
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Komisi Rujuk</div>
                      <div className="fw-semibold text-dark">{formatRp(selectedTarif.komisirujuk)}</div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <div className="d-flex justify-content-end gap-2 border-top pt-2">
                <Button variant="secondary" size="sm" onClick={() => setShowDetailModal(false)}>
                  Tutup
                </Button>
                <Button variant="primary" size="sm" className="fw-bold" onClick={() => { setShowDetailModal(false); handleOpenFormModal(selectedTarif); }}>
                  <i className="bi bi-pencil-square me-1"></i> Edit Tarif Kamar
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL FORM TAMBAH / EDIT TARIF KAMAR ══ */}
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)} centered backdrop="static" size="lg">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-pencil-square fs-5 text-warning"></i>
            <span>{isEditMode ? 'Edit Data Tarif Kamar' : 'Tambah Data Tarif Kamar Baru'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSaveTarifKamar}>
            <Row className="g-2">
              <Col md={12}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Kelas Kamar <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={formData.kd_kelas}
                    onChange={(e) => {
                      const selectedKd = e.target.value;
                      const selectedKelas = kelasOptions.find(k => k.kd_klas === selectedKd);
                      setFormData({ 
                        ...formData, 
                        kd_kelas: selectedKd, 
                        nm_kelas: selectedKelas ? selectedKelas.nm_klas : ''
                      });
                    }}
                    disabled={isEditMode}
                    required
                    style={{ fontSize: '0.82rem' }}
                  >
                    <option value="">-- Pilih Kelas Kamar --</option>
                    {kelasOptions.map((k, i) => (
                      <option key={i} value={k.kd_klas}>{k.kd_klas} - {k.nm_klas}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Tarif Paket (Rp)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.tarifpaket}
                    onChange={e => setFormData({ ...formData, tarifpaket: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Tarif Non-Paket (Rp)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.tarif}
                    onChange={e => setFormData({ ...formData, tarif: Number(e.target.value) })}
                    style={{ fontSize: '0.82rem' }}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Status Paket
                  </Form.Label>
                  <Form.Select
                    size="sm"
                    value={formData.sts_paket}
                    onChange={e => setFormData({ ...formData, sts_paket: e.target.value })}
                    style={{ fontSize: '0.82rem' }}
                  >
                    <option value="Paket">Paket</option>
                    <option value="Non Paket">Non Paket</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                    Selisih
                  </Form.Label>
                  <Form.Select
                    size="sm"
                    value={formData.selisih}
                    onChange={e => setFormData({ ...formData, selisih: e.target.value })}
                    style={{ fontSize: '0.82rem' }}
                  >
                    <option value="Tetap">Tetap</option>
                    <option value="Prosentase">Prosentase</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {formFeedback && (
              <div className={`alert alert-${formFeedback.type} py-1 px-2 mb-3 mt-2`} style={{ fontSize: '0.73rem' }}>
                <i className="bi bi-info-circle-fill me-1"></i>
                {formFeedback.text}
              </div>
            )}

            <div className="d-flex justify-content-end gap-2 border-top pt-2 mt-3">
              <Button type="button" variant="secondary" size="sm" onClick={() => setShowFormModal(false)} disabled={isSaving}>
                Batal
              </Button>
              <Button type="submit" size="sm" variant="success" className="fw-bold" disabled={isSaving}>
                {isSaving ? <Spinner size="sm" animation="border" className="me-1" /> : <i className="bi bi-save me-1"></i>}
                Simpan Tarif Kamar
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex', flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.25rem 1rem', flexShrink: 0,
  },
  mainContent: {
    flex: 1, padding: '0.4rem', overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '12px', border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff', overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.4rem 0.75rem', color: '#ffffff', fontWeight: 600, fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
};

export default TarifKamar;
